// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"303":"550ef2d7","430":"550ef2d7"}[chunkId] + ".chunk.css";
};